// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.maintenance.RentalManagerMaintenanceConfigWebApiHandler

import { frontEndRequestV2 } from '@zg-rentals/ts-client-fetch';
import type { RentalManagerEnvironment } from '@zg-rentals/rental-manager-env-base';

import type { RentalManagerMaintenanceConfigsDto } from '../..';

export const RentalManagerMaintenanceConfigWebApiHandler_config_Path = '/api/web/v1/maintenance/config';

/**
 * Get maintenance configs
 */
export const RentalManagerMaintenanceConfigWebApiHandler_config = (environment?: RentalManagerEnvironment) => {
  return frontEndRequestV2<never, never, RentalManagerMaintenanceConfigsDto>({
    endpoint: RentalManagerMaintenanceConfigWebApiHandler_config_Path,
    method: 'GET',
    contextPath: '/rental-manager-api',
    environment,
  });
};
